import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  data: null,
};

const aaDefOB = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_AA_DEF_OB_HODN_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_AA_DEF_OB_HODN_SUCCESS:
      return { ...state, isLoading: false, data: action.res.Data };

    case actionTypes.GET_AA_DEF_OB_HODN_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default aaDefOB;
